import React from "react";
import PropTypes from "prop-types";
import {
  XCircleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/solid";
import tw from "tailwind-styled-components";

const AlertWrapper = tw.div`
rounded-md p-4  my-3
${(p) => {
  if (p.color === "danger") return "bg-red-100";
  if (p.color === "success") return "bg-green-100";
  return "bg-blue-100";
}}
`;

const AlertIconWrapper = tw.div`
flex-shrink-0
`;

const AlertHeadingWrapper = tw.div`
text-sm 
font-medium 
${(p) => {
  if (p.color === "danger") return "text-red-800";
  if (p.color === "success") return "text-green-800";
  return "text-blue-800";
}}
`;

const AlertMessageWrapper = tw.div`
mt-2 
text-sm
${(p) => {
  if (p.color === "danger") return "text-red-700";
  if (p.color === "success") return "text-green-700";
  return "text-blue-700";
}}
`;
export default function Alert(props) {
  function getHeading() {
    switch (props.color) {
      case "danger":
        return "Error";
      case "success":
        return "Success";
      default:
        return "Info";
    }
  }

  function getIcon() {
    switch (props.color) {
      case "danger":
        return (
          <XCircleIcon className="h-5 w5 text-red-400" aria-hidden="true" />
        );
      case "success":
        return (
          <CheckCircleIcon
            className="h-5 w5 text-green-400"
            aria-hidden="true"
          />
        );
      default:
        return (
          <InformationCircleIcon
            className="h-5 w5 text-blue-400"
            aria-hidden="true"
          />
        );
    }
  }

  return (
    <AlertWrapper color={props.color}>
      <div className="flex">
        {" "}
        <AlertIconWrapper>{getIcon()}</AlertIconWrapper>
        <div className="ml-3">
          <AlertHeadingWrapper color={props.color}>
            {getHeading()}
          </AlertHeadingWrapper>
          <AlertMessageWrapper color={props.color}>
            <p className=" font-medium truncate">
              <span className="inline">{props.children}</span>
            </p>
          </AlertMessageWrapper>
        </div>
      </div>
    </AlertWrapper>
  );
}

Alert.propTypes = {
  children: PropTypes.any.isRequired,
  color: PropTypes.string.isRequired,
};
